// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDU7aAcQ3LHkNrOM9CrIBUR61u-kEscsNI",
  authDomain: "unknown-swamp-web.firebaseapp.com",
  projectId: "unknown-swamp-web",
  storageBucket: "unknown-swamp-web.appspot.com",
  messagingSenderId: "862587629775",
  appId: "1:862587629775:web:85454a734ebba92e8f07ba",
  measurementId: "G-P4RXCTWHBN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);